module.exports = "../study/imgs/maps/Nagano/S8/Helth/HeatDisorder/Nagano_HeatDisorder_HadGEM2_RCP45_End.png";